// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1HE2Z","fileBtn":"File_fileBtn__3aSR2","closeBtn":"File_closeBtn__1hIt3","fileSelected":"File_fileSelected__2E6R2","disabled":"File_disabled__3OCys"};